import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useFilters from '../useFilters';
import Helpers from 'helpers';
import UIHelper from 'helpers/UIHelper';
import _ from 'lodash';
import AnalyticsApi from 'libs/api/analytics';
import { usePdf } from '../../../../hooks/usePdf';

const api = new AnalyticsApi('charts/gender_brand/');

const format = (v) => `${v}%`;

const defaultState = {
  chart1: {
    barChart: [],
    maxValue: 0,
    barChangeLine: [],
  },
  chart2: {
    barChart: [],
    maxValue: 0,
    barChangeLine: [],
  },
  chart3: {
    barChart: [],
    maxValue: 0,
    barChangeLine: [],
  },
  chart4: {
    barChart: [],
    maxValue: 0,
    barChangeLine: [],
  },
};

const useInvoicesTickets = (isPrint, allReportsData, isAllReports) => {
  const { t } = useTranslation();
  const { handleDownloadPdf, loadingPdf, createCustomEvent } = usePdf();
  const { filters, title, searchParams } = useFilters(
    false,
    false,
    isAllReports,
  );
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(defaultState);
  const [errors, setErrors] = useState([]);

  const handleDownloadExcel = async () => {
    setLoading(true);
    try {
      const params = {
        ...Object.fromEntries([...searchParams]),
      };
      const response = await api.getExcel({ params });
      Helpers.downloadFile(response, 'file.xlsx');
    } catch (e) {
      const error = e?.response?.data?.errors || [t('Something went wrong!')];
      UIHelper.openNotificationWithIcon('error', error.join('\n'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const params = {
          ...Object.fromEntries([...searchParams]),
        };
        if (!params.by_period || !params.by_shopping_center) return;

        let table1, table2, table3, table4;

        if (!isAllReports) {
          const {
            data: {
              table1: backTable1,
              table2: backTable2,
              table3: backTable3,
              table4: backTable4,
            },
          } = await api.getFootfalls({ params });
          table1 = backTable1;
          table2 = backTable2;
          table3 = backTable3;
          table4 = backTable4;
        } else {
          const {
            table1: backTable1,
            table2: backTable2,
            table3: backTable3,
            table4: backTable4,
          } = allReportsData;
          table1 = backTable1;
          table2 = backTable2;
          table3 = backTable3;
          table4 = backTable4;
        }

        if (!table1 || !table2 || !table3 || !table4) return;

        const maxValueTable1 = Helpers.getMaxValuFromArrayOfObject(
          table1.data,
          'value',
        );

        const maxValueTable3Man = Helpers.getMaxValuFromArrayOfObject(
          table3.data,
          'Maschi',
        );

        const maxValueTable3Woman = Helpers.getMaxValuFromArrayOfObject(
          table3.data,
          'Femmine',
        );

        const maxValueTable2 = Helpers.getMaxValuFromArrayOfObject(
          table2.data,
          'value',
        );

        const maxValueTable4Man = Helpers.getMaxValuFromArrayOfObject(
          table4.data,
          'Maschi',
        );

        const maxValueTable4Woman = Helpers.getMaxValuFromArrayOfObject(
          table4.data,
          'Femmine',
        );

        const barChart1 = table1.data.map((i) => ({
          date: i.title,
          Gender: i.value,
          GenderColor: '#61cdbb',
        }));

        const barChart2 = table2.data.map((i) => ({
          date: i.title,
          Gender: i.value,
          GenderColor: '#61cdbb',
        }));

        const barChart3 = table3.data.map((i) => ({
          date: i.title,
          Maschi: i.Maschi,
          MaschiColor: '#61cdbb',
          Femmine: i.Femmine,
          FemmineColor: '#f47560',
        }));

        const barChart4 = table4.data.map((i) => ({
          date: i.title,
          Maschi: i.Maschi,
          MaschiColor: '#61cdbb',
          Femmine: i.Femmine,
          FemmineColor: '#f47560',
        }));

        setData({
          chart1: {
            barChart: barChart1,
            maxValue: maxValueTable1,
            barChangeLine: [],
            tableData: table1.data,
          },
          chart2: {
            barChart: barChart2,
            maxValue: maxValueTable2,
            tableData: table2.data,
            barChangeLine: [],
          },
          chart3: {
            barChart: barChart3,
            maxValue: _.max([maxValueTable3Man, maxValueTable3Woman]),
            barChangeLine: [],
            tableData: table1.data,
          },
          chart4: {
            barChart: barChart4,
            maxValue: _.max([maxValueTable4Man, maxValueTable4Woman]),
            barChangeLine: [],
            tableData: table1.data,
          },
        });
        setErrors([]);
      } catch (e) {
        console.log(e);
        const error = e?.response?.data?.date || [];
        if (error.length) {
          UIHelper.openNotificationWithIcon('error', error.join(', '));
        }
        setData(defaultState);
        setErrors(UIHelper.showAnalyticsError(e));
      } finally {
        setLoading(false);
        if (isPrint) {
          createCustomEvent();
        }
      }
    })();
  }, [searchParams, isPrint, allReportsData, isAllReports]);

  return {
    data,
    filters,
    format,
    loading,
    handleDownloadExcel,
    title,
    searchParams,
    handleDownloadPdf,
    loadingPdf,
    errors,
  };
};

export default useInvoicesTickets;
